import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

const domainTarget = { kind: "configuration" as const, field: "domain" };

export const tanium = defineConnector({
  identifier: "tanium",
  name: "Tanium",
  tagLine: "Endpoint management and security",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ domain }) =>
    domain ? `https://${domain.replace(/\./g, "\\.")}/.*` : "https://.*/.*",
  auth: (app) => headerAuth([{ name: "session", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Tanium server URL",
      items: [
        {
          kind: "input",
          label: "Server domain",
          required: true,
          placeholder: "tanium.example.com",
          target: domainTarget,
        },
      ],
    },
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the Tanium console, go to **Administration › API Tokens** and generate a new token.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/session/current`,
  },
});
